export default {
  data(){
    return {
      updating: false
    }
  },
  methods: {
    updateSuccessAlert() {
      return this.$toast("Perubahan berhasil disimpan", {
        type: "success",
        timeout: 10000
      });
    },
    update(value) {
      return Promise.resolve({ data: value });
    },
    handleUpdate(value) {
      this.updating = true;
      this.busy = true;
      this.update(value)
        .then(() => this.updateSuccessAlert())
        .then(() => {
          this.isEditing = false;
          return this.updated(value);
        })
        .then(() => {
          this.updating = false;
          this.busy = false;
        })
        .catch(error => {
          this.failedAlert(error);
          this.updating = false;
          this.busy = false;
        });
    },
    updated(value) {
      return Promise.resolve(value);
    }
  }
};
